import React, { useState, useMemo, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import styles from 'styles/jss/original/components/menus/menuModal';
import MenuModalList from '@/components/menus/MenuModalList';
import {
  MENU_SEARCH_TAXONOMY_COOKING,
  MENU_SEARCH_TAXONOMY_NONE_COOKING,
  MENU_TAXONOMY_COOKING,
  MENU_TAXONOMY_NONE_COOKING
} from '@/constants/app';
import classNames from 'classnames';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  taxonomyList: IMenuTaxonomy[];
};

const Transition = forwardRef(function Transition(props, ref) {
  // @ts-expect-error タイプ '{ children? ReactNode; direction: "down"; ref: ForwardedRef<unknown>; }' はタイプ 'SlideProps' に割り当てることができません。
  return <Slide direction='down' ref={ref} {...props} />;
});
Transition.displayName = 'Transition';

const MenuModal: React.FC<ComponentProps> = ({ taxonomyList }) => {
  const classes = useStyles();
  const [classicModal, setClassicModal] = useState(false);
  const params = useMemo(
    () => [
      {
        title: MENU_SEARCH_TAXONOMY_COOKING,
        list: taxonomyList.filter((item) => item.fields.type === MENU_TAXONOMY_COOKING)
      },
      {
        title: MENU_SEARCH_TAXONOMY_NONE_COOKING,
        list: taxonomyList.filter((item) => item.fields.type === MENU_TAXONOMY_NONE_COOKING)
      }
    ],
    [taxonomyList]
  );
  return (
    <>
      {/* @ts-expect-error */}
      <Button
        className={classes.buttonFloating}
        onClick={() => setClassicModal(true)}
        color='warning'
        justIcon
        round
      >
        <Search />
      </Button>
      <Dialog
        classes={{
          root: classes.modalRoot,
          paper: classes.modal
        }}
        open={classicModal}
        // @ts-expect-error
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setClassicModal(false)}
        aria-labelledby='classic-modal-slide-title'
        aria-describedby='classic-modal-slide-description'
      >
        <DialogTitle
          id='classic-modal-slide-title'
          disableTypography
          className={classes.modalHeader}
        >
          {/* @ts-expect-error */}
          <Button
            simple
            className={classes.modalCloseButton}
            key='close'
            aria-label='Close'
            onClick={() => setClassicModal(false)}
          >
            {' '}
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>献立を探す</h4>
        </DialogTitle>
        <DialogContent id='classic-modal-slide-description' className={classes.modalBody}>
          {params.map((item) => (
            <div key={item.title}>
              <MenuModalList
                title={item.title}
                taxonomyList={item.list}
                onClick={() => setClassicModal(false)}
              />
            </div>
          ))}
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          {/* @ts-expect-error */}
          <Button
            onClick={() => setClassicModal(false)}
            simple
            className={classNames(classes.description, classes.closeButton)}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MenuModal;
